module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"poLineItemsFilter":{"filterPlaceholder":"Enter Item #..."}}}')
  delete Component.options._Ctor
}
